import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ListPartitioner } from 'frontend-component-library';
import TagSearchGroup from './TagSearchGroup';
import { getTagCategory } from 'services/tagDisplayCategoriesService';

class TagSearchMenu extends PureComponent {
  getTagCategory = tag => getTagCategory(tag.schema);

  renderTagCategories = (category, tags) => {
    return (
      <li className="TagSearchMenu-category" key={category}>
        <TagSearchGroup
          groupName={category}
          tags={tags}
          onChange={this.props.onChange}
        />
      </li>
    );
  };

  render() {
    const { menuIsOpen } = this.props;
    if (!menuIsOpen) {
      return null;
    }

    return (
      <ul className="TagSearchMenu">
        <ListPartitioner
          items={this.props.options}
          splitter={this.getTagCategory}
          categoryRendererCallback={this.renderTagCategories}
        />
      </ul>
    );
  }
}

TagSearchMenu.propTypes = {
  menuIsOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.string,
};

export default TagSearchMenu;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/TagSearchBar/TagSearchMenu.js